export { default } from "./useEventRecordPost";
